import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { RouterModule } from '@angular/router';
import { SeparationModuleService } from '../separation-module.service';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../Util/Session/session.service';

@Component({
  selector: 'app-employee-resign-view',
  standalone: true,
  imports: [CommonModule, LoaderComponent, RouterModule, DataTablesModule],
  templateUrl: './employee-resign-view.component.html',
  styleUrl: './employee-resign-view.component.scss'
})
export class EmployeeResignViewComponent {

  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  TableDatas = [] as any;
  user = {} as any;

  constructor(
    private separation: SeparationModuleService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private session: SessionService
  ) {
    // this.common.getPageRights();
    this.user = session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetEmployeeDetail();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  exportToExcel() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
      return;
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Separation Policies');
    }
  }

  GetEmployeeDetail() {
    this.isDisabled = true;
    this.separation.EmpSeparationRequestLoad({
      SelectType: 1,
      EmpMasterID: this.user.UserId,
      EmpType: this.user.EmpType,
      EmpCode: this.user.EmpCode,
    }).subscribe({
      next: (response) => {
        this.TableDatas = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

}
